module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D07-clean-59dc4a14c4a20bab7732e933d93ebd49.png";